import * as apiCommon from '@/api/apiCommon'

// 登录
const apiName = '/api/auth'

// 获取短信验证
export function getMobileCode(data) {
	return apiCommon.save('webapi/auth/getMobileCode', data)
}

//手机号码登录
export function loginbyMobileCode(data) {
	return apiCommon.save('webapi/auth/loginbyMobileCode', data)
}

//手机账号登录
export function login(data) {
	return apiCommon.save(apiName + '/login', data)
}

// 获取图形验证码
export function getCode(data) {
	return apiCommon.save('/webapi/auth/getCode', data)
}

//验证码校验
export function verifyToken(data) {
	return apiCommon.save(apiName + '/verifyToken', data)
}


//二维码生成登录
export function getWebSiteWeixinLogin(data) {
	return apiCommon.save('/webapi/auth/getWebSiteWeixinLogin', data)
}

//二维码授权检验
export function loginByWebSiteWeixin(data) {
	return apiCommon.save('/webapi/auth/loginByWebSiteWeixin', data)
}

//登出
export function logout(data) {
	return apiCommon.save('/webapi/auth/logout', data)
}